module.exports = __webpack_public_path__ + "img/bg_gongxvtong.12782bfd.svg";